import * as Events from '../Events'

export default class LifeBarController {

  constructor(hearts, initialLife){
    this.hearts = hearts
    this.initalLife = initialLife
    this.currentLife = initialLife
    this.setLife(initialLife)
  }

  setLife(life){
    for(let i = 0; i < this.hearts.length; i ++){
      if(i < life){
        this.hearts[i].setHollow(false)
      }
      else {
        this.hearts[i].setHollow(true)
      }
    }
  }

  decrement(){
    this.currentLife --

    this.setLife(this.currentLife)

    if(this.currentLife === 0){
      Events.hub.publishEvent(Events.NO_LIFE_LEFT)
    } else {
      Events.hub.publishEvent(Events.ENABLE_QUESTION_BOX, {})
    }

  }

  reset(){
    this.currentLife = this.initalLife

    this.setLife(this.currentLife)
  }

}


// WEBPACK FOOTER //
// ./src/game/controllers/LifeBarController.js